export default {
  name: "SectionTitle",
  data() {
    return {};
  },
  methods: {},
};
